import gql from 'graphql-tag';
import { clients } from '../../../util/clients';

const { backend, backendRest } = clients.direct;

export const commonImport = {
  namespaced: true,
  state: () => ({
    taxYearList: [],
    latestTaxYear: 0,
    fileList: [],
  }),
  mutations: {
    setTaxYearList(state, list) {
      state.taxYearList = list;
    },
    setLatestTaxYear(state, list) {
      state.latestTaxYear = list;
    },
    setFileList(state, list) {
      state.fileList = list;
    },
  },
  getters: {
  },
  actions: {
    async uploadFileToDB({ commit, dispatch },
      criteria) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query uploadFileToDB ($criteria: uploadFileToDBCriteriaType) {
            uploadFileToDB (criteria: $criteria) { status }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { uploadFileToDB } = results.data;
        if (uploadFileToDB.status === 'OK') return true;
        dispatch('flashError', uploadFileToDB.status, { root: true });
        return false;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while importing', { root: true });
      }
      return false;
    },
    // async validateFileBeforeImportToDB({ commit, dispatch }, criteria) {
    //   let results;
    //   try {
    //     await dispatch('reAuth', null, { root: true });
    //     results = await backend.query({
    //       query: gql`query validateFileBeforeImportToDB ($criteria: uploadFileToDBCriteriaType) {
    //         validateFileBeforeImportToDB (criteria: $criteria) { status }
    //       }`,
    //       variables: {
    //         criteria,
    //       },
    //       fetchPolicy: 'no-cache',
    //     });
    //     clients.handleGQLErrors(results, commit);
    //     const { validateFileBeforeImportToDB } = results.data;
    //     if (validateFileBeforeImportToDB.status === 'OK') return true;
    //     dispatch('flashError', validateFileBeforeImportToDB.status, { root: true });
    //     return false;
    //   } catch (e) {
    //     dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
    //     dispatch('flashError', 'There was a problem while validating file', { root: true });
    //   }
    //   return false;
    // },
    async deleteFileInBackend({ commit, dispatch },
      { folderName, fileName }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query deleteFileInBackend ($criteria: uploadFileToDBCriteriaType) {
            deleteFileInBackend (criteria: $criteria) { status }
          }`,
          variables: {
            criteria: { folderName, fileName },
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { deleteFileInBackend } = results.data;
        if (deleteFileInBackend.status === 'OK') dispatch('flashSuccess', 'File deleted successfully', { root: true });
        else dispatch('flashError', deleteFileInBackend.status, { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting file', { root: true });
      }
    },
    async pollingToGetBackgroundProcess({ commit, dispatch }, { folderName }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query pollingToGetBackgroundProcess ($criteria: uploadFileToDBCriteriaType) {
            pollingToGetBackgroundProcess (criteria: $criteria) { status, count }
          }`,
          variables: {
            criteria: { folderName },
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { pollingToGetBackgroundProcess } = results.data;
        if (pollingToGetBackgroundProcess.status === '') dispatch('flashError', 'There was a problem determining the tax global variable.', { root: true });
        return pollingToGetBackgroundProcess;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem determining the tax global variable.', { root: true });
      }
      return '';
    },
    // async pollingToGetNewTaxrollErrorList({ commit, dispatch }, { folderName }) {
    //   let results;
    //   try {
    //     await dispatch('reAuth', null, { root: true });
    //     results = await backend.query({
    //       query: gql`query pollingToGetNewTaxrollErrorList
    // ($criteria: uploadFileToDBCriteriaType) {
    //         pollingToGetNewTaxrollErrorList (criteria: $criteria) { errorList }
    //       }`,
    //       variables: {
    //         criteria: { folderName },
    //       },
    //       fetchPolicy: 'no-cache',
    //     });
    //     clients.handleGQLErrors(results, commit);
    //     const { pollingToGetNewTaxrollErrorList } = results.data;
    //     if (pollingToGetNewTaxrollErrorList.status === '') dispatch('flashError',
    // 'There was a problem determining the tax global variable.', { root: true });
    //     return pollingToGetNewTaxrollErrorList;
    //   } catch (e) {
    //     dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
    //     dispatch('flashError', 'There was a problem
    // determining the tax global variable.', { root: true });
    //   }
    //   return '';
    // },
    async getFileListBasedOnFolderName({ commit, dispatch }, { folderName }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query getFileListBasedOnFolderName ($criteria: getFileListBasedOnFolderNameCriteriaType) {
            getFileListBasedOnFolderName (criteria: $criteria) { fileList }
          }`,
          variables: {
            criteria: { folderName },
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { getFileListBasedOnFolderName } = results.data;
        commit('setFileList', getFileListBasedOnFolderName.fileList);
        return getFileListBasedOnFolderName.fileList;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting DB.', { root: true });
      }
      return '';
    },
    /* Pulls one file back out of an import staging folder so the clerk can open it -
       mainly the composite/escrow PDFs that ship inside a Landmark archive. Fetched
       as a blob through the authenticated client rather than window.open, so the JWT
       travels in the Authorization header and never ends up in a URL. */
    async downloadFileFromBackend({ dispatch }, { folderName, fileName }) {
      try {
        await dispatch('reAuth', null, { root: true });
        const resp = await backendRest.get('/landmark/ftp/download', {
          params: { folderName, fileName },
          responseType: 'blob',
        });
        const url = URL.createObjectURL(resp.data);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        // the click is synchronous but the browser still needs the object alive to
        // finish writing the file, so the handle is released on a delay
        setTimeout(() => URL.revokeObjectURL(url), 10000);
        return true;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', `Unable to download ${fileName}.`, { root: true });
      }
      return false;
    },
  },
};

export default commonImport;
